import script from "./PublicSecurityInspection.vue?vue&type=script&setup=true&lang=js"
export * from "./PublicSecurityInspection.vue?vue&type=script&setup=true&lang=js"

import "./PublicSecurityInspection.vue?vue&type=style&index=0&id=3f936fc8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f936fc8"]])

export default __exports__